module.exports = __webpack_public_path__ + "img/oursolution1.6b093f7a.png";